import { createContext, useContext, useState, useCallback } from "react";

const ConsultationContext = createContext(null);

export function ConsultationProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState(null);

  const openConsultation = useCallback((interest) => {
    setPreset(interest || null);
    setOpen(true);
  }, []);

  return (
    <ConsultationContext.Provider value={{ open, setOpen, preset, openConsultation }}>
      {children}
    </ConsultationContext.Provider>
  );
}

export const useConsultation = () => useContext(ConsultationContext);
